import { createRouter, createWebHistory } from 'vue-router'
import PerfilColla from '../views/PlantillaColla.vue'
import PerfilGrup from '../views/PlantillaGrup.vue'

const routes = [
  {
    path: '/',
    name: 'mosaic',
    component: () => import('../views/visualitzacions/Mosaic.vue'),
    meta:{title:'Mosaic Casteller'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/about/AboutView.vue'),
    meta:{title:'Sobre el Mosaic - Mosaic Casteller',
      description:'Descripció i explicació del projecte Mosaic Casteller.'}
  },
  {
    path: '/colles',
    name: 'colles',
    component: () => import('../views/visualitzacions/Colles.vue'),
    meta:{title:'Colles - Mosaic Casteller',
      description:'Llista de totes les colles del Mosaic Casteller, mostrant les seves dades principals.'}
  },
  {
    path: '/liniatemporal',
    name: 'liniatemporal',
    component: () => import('../views/visualitzacions/LiniaTemporal.vue'),
    meta:{title:'Linia Temporal - Mosaic Casteller',
      description:'Visualització de la història de totes les Colles Castelleres, amb les etapes de cada una sobre un eix cronològic.'}
  },
  {
    path:"/mapa",
    name:"mapa",
    component: () => import('../views/visualitzacions/Mapa.vue'),
    meta:{title:'Mapa - Mosaic Casteller',
      description:'Mapa interactiu mostrant la ubicació de totes les Colles Castelleres.'}
  },
  {
    path:"/avistaments",
    name:"avistaments",
    component: () => import('../views/about/Avistament.vue'),
    meta:{title:'Avistaments - Mosaic Casteller',
      description:"Col·lecció de fotografies dels escuts de les Colles Castelleres."
    }
  },
  {
    path:"/colles/:id",
    name:"perfil-colla",
    component: PerfilColla,
    props:true
  } ,
  {
    path:"/altres/:id",
    name:"perfil-altre",
    component: PerfilColla,
    props:true
  }  ,
  {
    path:"/grups/:id",
    name:"perfil-grup",
    component: PerfilGrup,
    props:true
  }  ,
  {
    path:"/jocs/trobacolla",
    name:"trobacolla",
    component: () => import('../views/jocs/TrobaColla.vue'),
    meta:{title:'TrobaColla - Mosaic Casteller',
      description:"L'enigma casteller inspirat en el clàssic modern Wordle (o Trobamot). Cada dia hi ha una nova colla del dia per descobrir."}
  },
  {
    path:'/:pathMatch(.*)*',
    name:"404",
    component: () => import('../views/404.vue'),
    meta:{title:'404 - Mosaic Casteller'}
  },
  {
    path:"/informaciopendent",
    component: () => import('../views/about/InformacioPendent.vue'),
    meta:{title:'Informació Pendent - Mosaic Casteller',
      description:"Dades, imatges i altres detalls del mosaic que estan pendents de trobar o d'una millor font d'informació"}
  
  },
  {
    path:"/jocs/picacamises",
    component: () => import('../views/jocs/PicaCamises.vue'),
    meta:{title:'PicaCamises - Mosaic Casteller',
      description:""}
  
  },
  {
    path:"/jocs/4colors",
    component: () => import('../views/jocs/4Colors.vue'),
    meta:{title:'4 Colors - Mosaic Casteller',
      description:"Joc en format test per a posar a prova els teus coneixements sobre els colors de les colles castelleres."}
  
  },
  { path:"/webgrafia",
    component: () => import('../views/about/WebGrafia.vue'),
    meta:{title:'Webgrafia - Mosaic Casteller',
      description:"Fonts d'informació i projectes relacionats amb el món casteller."}
  },
  {
    path:"/provacomparacolor",
    component: () => import('../views/debug/ProvaComparaColor.vue')
  },
  {
    path:"/oklch",
    component: () => import('../views/debug/Oklch.vue')
  },
  {
    path:"/arbre",
    component: () => import('../views/visualitzacions/ArbreGenealogic.vue')
  },
  {
    path:"/debug",
    component: () => import('../views/debug/debug.vue')
  },
  {
    path:"/actualitza",
    component: () => import('../views/Actualitza.vue')
  },
  {
    path:"/altres",
    redirect: '/#altres' // Redirects to the root path
  },
  {
    path:"/gamma/universitaria",
    component: () => import('../views/GammaUniversitaria.vue'),
    meta:{title:'Taula de Puntuació Universitaria 2025-2026 - Mosaic Casteller',
      description:"Taula de puntuació universitària 2025-2026. Oberta a suggeriments i possibilitat de canvis."}
  },{
    path: '/barometre-universitari',
    redirect: '/' // Redirects to the root path
  },
  {
    path:"/provavarometresupersecreta",
    component: () => import('../views/BarometreUniversitari.vue')
  },
  {path:"/changelog",
    component: () => import('../views/about/ChangeLog.vue'),
  }

]

const router = createRouter({
  history: createWebHistory(), // Equivalent to mode: "history"
  routes,
  
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title; // Set the document title based on the route meta field
  }
  next(); // Continue with the navigation
});

export default router;